// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Code } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCode(props: any) {
    return <IconBase icon={Code} {...props} />
  }

  export default IconCode
  